"use strict"

import dispatcher from "./../dispatcher";
import {Singleton} from "vwa/flux";

const mapTooltipStore = new Singleton();
export default mapTooltipStore;

window.mapTooltipStore = mapTooltipStore;

dispatcher.on("createTooltip", (id, position, label, icon = null) => {
	mapTooltipStore.set({
		id,
		position,
		icon,
		label
	});
});

dispatcher.on("removeTooltip", id => {
	const descriptor = mapTooltipStore.get();
	if(descriptor && id == descriptor.id){
		mapTooltipStore.set(null);
	}
});


// WEBPACK FOOTER //
// ./src/store/mapTooltip.js